import { useMemo } from 'react'
import { View, Text, Pressable, Platform } from 'react-native'
import { WEB_HOVER_TRANSITION_STYLE } from '../../constants/animations'
import { useTheme } from '../../../theme/useTheme'
import { DATA_LOAD_ERROR_COPY } from '../../constants/dataLoadError.constants'
import { getDataLoadErrorPanelStyles } from './DataLoadErrorPanel.styles'

interface DataLoadErrorPanelProps {
  title?: string
  message?: string
  retryLabel?: string
  onRetry: () => void
  testID?: string
}

export function DataLoadErrorPanel({
  title = DATA_LOAD_ERROR_COPY.TITLE,
  message = DATA_LOAD_ERROR_COPY.MESSAGE,
  retryLabel = DATA_LOAD_ERROR_COPY.RETRY,
  onRetry,
  testID = 'data-load-error-panel',
}: DataLoadErrorPanelProps) {
  const theme = useTheme()
  const styles = useMemo(() => getDataLoadErrorPanelStyles(theme), [theme])

  return (
    <View style={styles.container} testID={testID}>
      <Text style={styles.title}>{title}</Text>
      <Text style={styles.message}>{message}</Text>
      <Pressable
        style={({ pressed, hovered }) => [
          styles.retryButton,
          Platform.select({ web: WEB_HOVER_TRANSITION_STYLE }),
          pressed && styles.retryButtonPressed,
          hovered && Platform.OS === 'web' && styles.retryButtonHover,
        ]}
        onPress={onRetry}
        accessibilityRole="button"
        accessibilityLabel={retryLabel}
        testID={`${testID}-retry`}
      >
        <Text style={styles.retryButtonText}>{retryLabel}</Text>
      </Pressable>
    </View>
  )
}
